"use client";
import { motion } from "framer-motion";
import { Box } from "@mui/material";
import * as React from "react";

export function LettersPullUp({
	text,
	className = "",
	pullUpDelay = 0.05,
}: {
	text: string;
	className?: string;
	pullUpDelay?: number;
}) {
	const lines = text.split("\n");

	const pullUpVariant = {
		initial: {
			y: 10,
			opacity: 0,
		},
		animate: (i: number) => ({
			y: 0,
			opacity: 1,
			transition: {
				delay: i * pullUpDelay,
			},
		}),
	};

	let letterIndex = 0;

	return (
		<Box>
			{lines.map((line, lineIndex) => (
				<Box
					key={lineIndex}
					display="flex"
					flexWrap="wrap"
				>
					{line.split("").map((char) => {
						const index = letterIndex++;

						return (
							<motion.span
								key={index}
								variants={pullUpVariant}
								initial="initial"
								animate="animate"
								custom={index}
								className={className}
								style={{ display: "inline-block" }}
							>
								{char === " " ? "\u00A0" : char}
							</motion.span>
						);
					})}
				</Box>
			))}
		</Box>
	);
}
